export default "__VITE_ASSET__Bqps847L__"